module.exports = __webpack_public_path__ + "img/l3-a.ed083207.png";